import React from 'react';
import { WidgetProps } from '@/lib/widgets/types';
import { StatsWidget } from './StatsWidget';
import { useFleetAlerts } from '@/hooks/use-fleet-alerts';
import { useFleetDashboardStats } from '@/hooks/use-fleet-dashboard-stats';
import { useAuth } from '@/hooks/use-auth';

export function FleetActiveVehiclesWidget(props: WidgetProps) {
  const { data: stats, isLoading } = useFleetDashboardStats();
  
  return (
    <StatsWidget
      {...props}
      title="Veículos Ativos"
      value={isLoading ? "..." : stats?.activeVehicles?.toString() || "0"}
      description="Frota operacional"
      icon="Truck"
      colorScheme="vehicles"
      isLoading={isLoading}
    />
  );
}

export function FleetMaintenanceWidget(props: WidgetProps) {
  const { data: stats, isLoading } = useFleetDashboardStats();
  
  return (
    <StatsWidget
      {...props}
      title="Manutenções Pendentes"
      value={isLoading ? "..." : stats?.pendingMaintenances?.toString() || "0"}
      description="Aguardando execução"
      icon="Wrench"
      colorScheme="maintenance"
      isLoading={isLoading}
    />
  );
}

export function FleetAlertsWidget(props: WidgetProps) {
  const { user } = useAuth();
  const companyId = user?.user_metadata?.company_id;
  const { data: alerts = [] } = useFleetAlerts(companyId);
  
  const activeAlerts = alerts.filter(alert => alert.status === 'active');
  
  return (
    <StatsWidget
      {...props}
      title="Alertas Ativos"
      value={activeAlerts.length}
      description="Requerem atenção"
      icon="AlertTriangle"
      colorScheme="alerts"
    />
  );
}

export function FleetFuelWidget(props: WidgetProps) {
  const { data: stats, isLoading } = useFleetDashboardStats();
  
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };
  
  return (
    <StatsWidget
      {...props}
      title="Combustível Mensal"
      value={isLoading ? "..." : formatCurrency(stats?.monthlyFuelCost || 0)}
      description="Gasto no mês"
      icon="Fuel"
      colorScheme="fuel"
      isLoading={isLoading}
    />
  );
}